/*
  Bundle Builder - Jhango
  Vision Theme Compatible with Street Theme Design
  © 2024 Jhango
  https://www.jhango.com
*/
console.log('Bundle Builder Jhango - Vision Theme Compatible with Street Theme Design | Learn more at https://www.JHANGO.com')

class BundleBuilderJhango extends HTMLElement {
  constructor () {
    super()

    this.bundleContents = JSON.parse(localStorage.getItem('jhango-bundle-contents')) || []
    this.card = this.querySelector('#collection-bundle-card-jhango')

    this.buildBundle()
    this.calcPrices()
    this.handleCartStickyPosition()
    this.animateBtnBundleCheckout()
    this.initStickyMobileCard()

    this.querySelectorAll('.product-card form').forEach(form => {
      form.addEventListener('submit', (e) => {
        e.preventDefault()
        this.addToBundle(form)
      })
    })

    this.querySelectorAll('.product-card select[name="id"]').forEach(select => {
      select.addEventListener('change', () => this.onChangeProductCardVariant(select))
    })

    this.querySelectorAll('.collection-bundle-card-list-jhango .btn-close').forEach(btn => {
      btn.addEventListener('click', (e) => {
        this.removeFromBundle(btn)
      })
    })

    this.querySelectorAll('.btn-bundle-checkout').forEach(btn => {
      btn.addEventListener('click', () => this.handleCheckout(btn))
    })
  }

  addToBundle (form) {
    const btn = form.querySelector('.btn-add-to-bundle')
    const select = form.querySelector('select[name="id"]')
    const hiddenInput = form.querySelector('input[name="id"]')
    
    let selectedOption
    if (select && select.selectedIndex >= 0) {
      selectedOption = select.options[select.selectedIndex]
    } else if (hiddenInput) {
      selectedOption = hiddenInput
    } else {
      console.error('No variant selector found')
      return
    }

    this.bundleContents.push({
      product_id: Number(selectedOption.dataset.productId),
      product_title: selectedOption.dataset.productTitle,
      variant_id: Number(selectedOption.dataset.variantId),
      variant_img: selectedOption.dataset.variantImg,
      variant_price: Number(selectedOption.dataset.variantPrice)
    })

    localStorage.setItem('jhango-bundle-contents', JSON.stringify(this.bundleContents))
    console.log('Bundle contents:', this.bundleContents)

    this.buildBundle()
    this.calcPrices()

    // Button feedback - use the text content inside the span
    const textSpan = btn.querySelector('.product-card--add-to-cart-text')
    const originalText = textSpan.textContent
    textSpan.textContent = btn.dataset.textAddedToBundle || '✓ Added to Bundle!'
    
    setTimeout(() => {
      textSpan.textContent = btn.dataset.textAddToBundle || originalText
    }, 2000)
  }

  removeFromBundle (btn) {
    this.bundleContents = this.bundleContents.filter((elem, index) =>
      index !== Number(btn.dataset.number - 1))

    localStorage.setItem('jhango-bundle-contents', JSON.stringify(this.bundleContents))

    this.buildBundle()
    this.calcPrices()

    this.querySelector('#collection-bundle-card-jhango').focus()
  }

  buildBundle () {
    this.querySelectorAll('.collection-bundle-card-list-jhango li').forEach((elem, index) => {
      const bundleElem = this.bundleContents[index]
      const img = elem.querySelector('img')

      if (bundleElem) {
        elem.classList.add('active')
        img.setAttribute('src', bundleElem.variant_img)
        img.setAttribute('alt', bundleElem.product_title)
        img.setAttribute('data-bs-toggle', 'tooltip')
        img.setAttribute('data-bs-placement', 'top')
        img.setAttribute('data-bs-title', bundleElem.product_title)
        elem.querySelector('.btn-close').setAttribute('data-variant-id', bundleElem.variant_id)
      } else {
        elem.classList.remove('active')
        img.setAttribute('src', img.dataset.src)
        img.setAttribute('alt', '')
        img.removeAttribute('data-bs-toggle')
        img.removeAttribute('data-bs-placement')
        img.removeAttribute('data-bs-title')
        elem.querySelector('.btn-close').removeAttribute('data-variant-id')
      }
    })

    this.querySelectorAll('.collection-bundle-card-list-wrapper-jhango').forEach(elem => {
      if (Number(elem.dataset.tierQty) <= this.bundleContents.length) {
        elem.classList.add('active')
      } else {
        elem.classList.remove('active')
      }
    })

    this.querySelectorAll('.btn-bundle-checkout').forEach(btn => { btn.disabled = true })

    // Check if any tier goal is met
    window.theme.bundle_builder_tiers_jhango.forEach(tier => {
      if (tier.qty === this.bundleContents.length) {
        this.querySelectorAll('.btn-bundle-checkout').forEach(btn => { btn.disabled = false })
      }
    })

    const maxQty = window.theme.bundle_builder_tiers_jhango[window.theme.bundle_builder_tiers_jhango.length - 1].qty

    if (this.bundleContents.length === maxQty) {
      this.querySelectorAll('.btn-add-to-bundle').forEach(elem => { elem.disabled = true })
    } else {
      this.querySelectorAll('.btn-add-to-bundle').forEach(elem => { elem.disabled = false })
    }
  }

  calcPrices () {
    const totalPrice = this.bundleContents.reduce((accumulator, currentValue) =>
      currentValue.variant_price + accumulator, 0)

    const currentQty = this.bundleContents.length
    let discount = 0
    let savings = 0

    window.theme.bundle_builder_tiers_jhango.forEach(tier => {
      if (tier.qty <= currentQty) {
        discount = tier.discount
      }
    })

    if (discount > 0) {
      savings = discount / 100 * totalPrice
    }

    this.querySelectorAll('[data-bundle-price]').forEach(elem => {
      elem.textContent = this.formatMoney(totalPrice)
    })

    this.querySelectorAll('[data-you-save]').forEach(elem => {
      elem.textContent = `${this.formatMoney(savings)} (${discount}%)`
    })
  }

  formatMoney(cents) {
    if (window.Shopify && window.Shopify.formatMoney) {
      return window.Shopify.formatMoney(cents)
    }
    // Try to get currency from products or use rupees as fallback
    let currencySymbol = 'Rs.'
    try {
      // Try to detect currency from existing prices on the page
      const priceElement = document.querySelector('.price .amount')
      if (priceElement && priceElement.textContent) {
        const priceText = priceElement.textContent.trim()
        if (priceText.includes('₹')) {
          currencySymbol = '₹'
        } else if (priceText.includes('Rs.')) {
          currencySymbol = 'Rs.'
        }
      }
    } catch (e) {
      console.log('Currency detection failed, using Rs. as fallback')
    }
    // Fallback formatting with proper currency
    return currencySymbol + ' ' + (cents / 100).toFixed(2)
  }

  handleCartStickyPosition () {
    if (window.matchMedia('(min-width: 800px)').matches) {
      const headerGroup = document.querySelector('#header-group.sticky-top') || document.querySelector('header.header') || document.querySelector('#header-group')
      
      let oldScroll = window.scrollY

      window.addEventListener('scroll', () => {
        const newScroll = window.scrollY
        const headerHeight = headerGroup ? headerGroup.clientHeight : 80
        
        if (newScroll > oldScroll) {
          if (newScroll > headerHeight) {
            this.card.style.top = '20px'
          }
        } else if (newScroll < oldScroll) {
          this.card.style.top = `${headerHeight + 20}px`
        }

        oldScroll = Math.max(window.scrollY, 0)
      })
    }
  }

  onChangeProductCardVariant (select) {
    const variantImg = select[select.selectedIndex].dataset.variantImg

    if (variantImg && variantImg.length) {
      const productCard = select.closest('.product-card')
      const img = productCard.querySelector('.product-card-image img, .product-featured-image img')
      if (img) {
        img.setAttribute('src', variantImg)
      }
    }
  }

  animateBtnBundleCheckout () {
    const animate = () => {
      this.querySelectorAll('.btn-bundle-checkout').forEach(btn => {
        if (!btn.disabled) {
          btn.classList.add('animate__animated', 'animate__shakeX')
        }
      })
      setTimeout(() => {
        this.querySelectorAll('.btn-bundle-checkout').forEach(btn => {
          btn.classList.remove('animate__animated', 'animate__shakeX')
        })
      }, 1000)
    }
    animate()

    setTimeout(() => {
      setInterval(() => {
        animate()
      }, 4000)
    }, 1000)
  }

  async handleCheckout (btn) {
    btn.classList.add('loading')
    btn.disabled = true
    btn.setAttribute('aria-busy', 'true')

    const items = []

    this.bundleContents.forEach(elem => {
      items.push({
        id: elem.variant_id,
        quantity: 1
      })
    })

    try {
      if (btn.dataset.redirectToCheckout === 'true') {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items })
        })
        window.location.href = '/checkout'
      } else {
        // Add to cart without redirect
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items })
        })
        
        // Trigger cart update events if available
        if (document.querySelector('cart-drawer')) {
          document.querySelector('cart-drawer').updateCart()
        } else if (document.querySelector('cart-container')) {
          document.querySelector('cart-container').add({ items })
        }
      }

      btn.classList.remove('loading')
      btn.disabled = false
      btn.setAttribute('aria-busy', 'false')

      this.bundleContents = []
      localStorage.setItem('jhango-bundle-contents', JSON.stringify(this.bundleContents))
      this.buildBundle()
      this.calcPrices()

      // Show success message
      const successMsg = document.createElement('div')
      successMsg.innerHTML = '✅ Bundle added to cart!'
      successMsg.style.cssText = 'position:fixed;top:20px;right:20px;background:#10b981;color:white;padding:1rem;border-radius:8px;z-index:9999;'
      document.body.appendChild(successMsg)
      setTimeout(() => successMsg.remove(), 3000)

    } catch (error) {
      console.error('Error adding bundle to cart:', error)
      btn.classList.remove('loading')
      btn.disabled = false
      btn.setAttribute('aria-busy', 'false')
    }
  }

  initStickyMobileCard () {
    const stickyCard = this.querySelector('#collection-bundle-sticky-mobile-card-jhango')
    if (!stickyCard) return

    const top = document.querySelector('#collection-bundle-card-jhango').getBoundingClientRect().top + window.scrollY
    let isSticky = false // Track current state to prevent unnecessary changes

    window.addEventListener('scroll', () => {
      if (window.matchMedia('(min-width: 800px)').matches) {
        // On desktop, ensure sticky card is hidden and no padding
        if (isSticky) {
          stickyCard.classList.remove('show')
          document.body.classList.remove('bundle-sticky-active')
          isSticky = false
        }
        return
      }

      const shouldBeSticky = window.scrollY > top + 200 // Add some buffer

      if (shouldBeSticky && !isSticky) {
        // Show sticky card and add CSS class for padding
        stickyCard.classList.add('show')
        document.body.classList.add('bundle-sticky-active')
        isSticky = true
      } else if (!shouldBeSticky && isSticky) {
        // Hide sticky card and remove CSS class
        stickyCard.classList.remove('show')
        document.body.classList.remove('bundle-sticky-active')
        isSticky = false
      }
    })

    const btnScrollBundleCard = stickyCard.querySelector('.btn-scroll-bundle-card')
    const headerGroup = document.querySelector('#header-group.sticky-top') || document.querySelector('header.header') || document.querySelector('#header-group')
    const headerHeight = headerGroup ? headerGroup.clientHeight : 80

    btnScrollBundleCard?.addEventListener('click', (e) => {
      const bundleCard = document.querySelector('#collection-bundle-card-jhango')
      const targetPosition = bundleCard.getBoundingClientRect().top + window.scrollY - headerHeight - 16
      
      window.scrollTo({
        behavior: 'smooth',
        top: targetPosition
      })
    })
  }
}

// Register custom element
customElements.define('bundle-builder-jhango', BundleBuilderJhango)